"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useState } from "react";
import { api, createTRPCReactClient } from "~/utils/api";

// // // //

/**
 * Provides the tRPC client + react-query client to the child components.
 * Owns a single `QueryClient` shared by the tRPC hooks (`api.*`) AND raw react-query hooks
 * NOTE - the clients are created with `useState` instead of at module scope so
 * they are NOT shared across requests when this component renders on the server
 */
export function TRPCReactProvider(props: { children: React.ReactNode }) {
    /**
     * @link https://tanstack.com/query/v4/docs/reference/QueryClient
     **/
    const [queryClient] = useState(
        () => new QueryClient(),
        // new QueryClient({
        //     defaultOptions: {
        //         queries: {
        //             staleTime: 5 * 60 * 1000, // 5 min - data is "fresh"
        //             cacheTime: 30 * 60 * 1000, // 30 min - keep in memory
        //             refetchOnWindowFocus: false, // Don't refetch on tab switch
        //         },
        //     },
        // }),
    );

    const [trpcClient] = useState(() => createTRPCReactClient());

    return (
        <api.Provider client={trpcClient} queryClient={queryClient}>
            <QueryClientProvider client={queryClient}>
                {props.children}
            </QueryClientProvider>
        </api.Provider>
    );
}
